import { Injectable } from '@angular/core';
import { CachedDataService } from './cached-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ITopSkill } from '../models/top-skill.model';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable()
export class TopSkillService {
  endpoint = '/api/TopSkills';

  constructor(private http: HttpClient, private cachedDataService: CachedDataService) { }

  getTopSkills(): Observable<ITopSkill[]> {
    const url = this.endpoint + '/GetTopSkills';
    return this.cachedDataService.getOrSet<ITopSkill[]>(
      'top-skills.getTopSkills',
      () => this.http.get<ITopSkill[]>(url, httpOptions),
      10 * 60 * 1000 // 10 minutes
    );
  }

  getTopSkillsForUser(id: string): Observable<ITopSkill[]> {
    const url = this.endpoint + '/GetTopSkillsForUserId/';
    return this.http.get<ITopSkill[]>(url, { params: { id: id.toString() } });
  }
}
